export const brandTokens = {
  colorPrimary: "#0f9d90",
  colorPrimaryHover: "#0c877c",
  colorPrimaryActive: "#0a6f66",
  colorInk: "#1f2933",
  colorHeading: "#102a43",
  colorSurface: "#ffffff",
  colorSurfaceAlt: "#f8fcfd",
  colorLayout: "#f2f6f7",
  colorBorder: "#d9e6eb",
  colorSuccess: "#2f855a",
  colorWarning: "#d69e2e",
  colorError: "#c53030",
  colorInfo: "#0f9d90",
  colorNavBg: "#114b5f",
  colorNavHover: "#16697a",
  radiusSm: 16,
  radiusMd: 20,
  radiusLg: 24,
  radiusPill: 999,
  spacingXs: 4,
  spacingSm: 8,
  spacingMd: 12,
  spacingLg: 16,
  spacingXl: 24,
} as const;

export const appTheme = {
  token: {
    colorPrimary: brandTokens.colorPrimary,
    colorInfo: brandTokens.colorInfo,
    colorSuccess: brandTokens.colorSuccess,
    colorWarning: brandTokens.colorWarning,
    colorError: brandTokens.colorError,
    borderRadius: brandTokens.radiusLg,
    borderRadiusSM: brandTokens.radiusSm,
    borderRadiusLG: brandTokens.radiusLg,
    borderRadiusXS: 10,
    controlHeight: 44,
    controlHeightLG: 52,
    controlHeightSM: 36,
    fontFamily: 'Inter, "Segoe UI", ui-sans-serif, system-ui, sans-serif',
    colorBgLayout: brandTokens.colorLayout,
    colorBgContainer: brandTokens.colorSurface,
    colorText: brandTokens.colorInk,
    colorTextHeading: brandTokens.colorHeading,
    colorBorder: brandTokens.colorBorder,
  },
  components: {
    Layout: {
      siderBg: brandTokens.colorNavBg,
      headerBg: brandTokens.colorSurfaceAlt,
      bodyBg: brandTokens.colorLayout,
    },
    Menu: {
      darkItemBg: brandTokens.colorNavBg,
      darkSubMenuItemBg: brandTokens.colorNavBg,
      darkItemColor: "#e6f4f8",
      darkItemHoverBg: brandTokens.colorNavHover,
      darkItemSelectedBg: brandTokens.colorPrimary,
      darkItemSelectedColor: "#ffffff",
    },
    Card: {
      headerBg: brandTokens.colorSurfaceAlt,
      borderRadiusLG: brandTokens.radiusLg,
      paddingLG: 28,
    },
    Button: {
      defaultBorderColor: "#bfd5dc",
      defaultColor: brandTokens.colorNavBg,
      borderRadius: brandTokens.radiusPill,
      borderRadiusLG: brandTokens.radiusPill,
      borderRadiusSM: brandTokens.radiusPill,
      controlHeight: 44,
      controlHeightLG: 52,
      controlHeightSM: 36,
      fontWeight: 720,
      paddingInline: 24,
      paddingInlineLG: 28,
    },
    Input: {
      borderRadius: brandTokens.radiusSm,
      controlHeight: 44,
      controlHeightLG: 52,
    },
    InputNumber: {
      borderRadius: brandTokens.radiusSm,
      controlHeight: 44,
    },
    Select: {
      borderRadius: brandTokens.radiusSm,
      controlHeight: 44,
      controlHeightLG: 52,
    },
    Tag: {
      borderRadiusSM: brandTokens.radiusPill,
    },
    Tooltip: {
      borderRadius: brandTokens.radiusSm,
      borderRadiusOuter: brandTokens.radiusSm,
      borderRadiusSM: brandTokens.radiusSm,
      borderRadiusXS: brandTokens.radiusSm,
      paddingSM: 6,
      paddingXS: 6,
    },
    Tabs: {
      itemSelectedColor: brandTokens.colorPrimary,
      itemHoverColor: brandTokens.colorPrimaryHover,
      inkBarColor: brandTokens.colorPrimary,
    },
  },
} as const;
